import React, { FC } from "react";
import { FallbackContainer } from "./styledComponents";

const ReviewsCarouselFallback: FC = () => {
  return <FallbackContainer />;
};

export default ReviewsCarouselFallback;
